"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAxiosClient = exports.useAxios = exports.AxiosContext = void 0;
var tslib_1 = require("tslib");
var react_1 = require("react");
exports.AxiosContext = (0, react_1.createContext)({
    client: null,
});
function useAxios(defaultOptions) {
    if (defaultOptions === void 0) { defaultOptions = {}; }
    var client = useAxiosClient();
    var _a = (0, react_1.useState)(), data = _a[0], setData = _a[1];
    var _b = (0, react_1.useState)(false), loading = _b[0], setLoading = _b[1];
    var _c = (0, react_1.useState)(), error = _c[0], setError = _c[1];
    function request(options) {
        if (options === void 0) { options = {}; }
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
            var res, e_1, axiosError;
            return (0, tslib_1.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLoading(true);
                        setError(undefined);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4, client.request((0, tslib_1.__assign)((0, tslib_1.__assign)({}, defaultOptions), options))];
                    case 2:
                        res = _a.sent();
                        setData(res.data);
                        return [2, res.data];
                    case 3:
                        e_1 = _a.sent();
                        axiosError = e_1;
                        setError(axiosError);
                        throw e_1;
                    case 4:
                        setLoading(false);
                        return [7];
                    case 5: return [2];
                }
            });
        });
    }
    return [
        (0, react_1.useCallback)(request, [client]),
        {
            data: data,
            loading: loading,
            error: error,
        },
    ];
}
exports.useAxios = useAxios;
function useAxiosClient() {
    var client = (0, react_1.useContext)(exports.AxiosContext).client;
    if (!client) {
        throw new Error('Axios client must be set on AxiosContext');
    }
    return client;
}
exports.useAxiosClient = useAxiosClient;
//# sourceMappingURL=axios.js.map